module.exports = __webpack_public_path__ + "static/media/galacticblue219400989.56cb4b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/galacticblue219400989.png
// module id = 508
// module chunks = 0